import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./style.min.css";

import enFlag from "../../assets/svg/en.svg";
import frFlag from "../../assets/svg/fr.svg";
import arFlag from "../../assets/svg/ar.svg";

const languages = [
  { code: "en", label: "English", flag: enFlag },
  { code: "fr", label: "Français", flag: frFlag },
  { code: "ar", label: "العربية", flag: arFlag },
];

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const currentLang = localStorage.getItem("i18nextLng") || "fr";
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(currentLang);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    setSelected(code);
    i18n.changeLanguage(code);
    localStorage.setItem("i18nextLng", code);
    setIsOpen(false);
  };

  return (
    <div className="language-dropdown" ref={ref}>
  <button aria-label="Choisir la langue" aria-expanded={isOpen} aria-controls="language-options" className="lang-toggle" onClick={() => setIsOpen(!isOpen)}>
  <img
    src={languages.find((l) => l.code === selected)?.flag}
    alt={selected}
    width="24" height="18" className="flag-img"
  />
  <span className="arrow">▾</span>
</button>

      {isOpen && (
      <ul id="language-options" className="lang-menu" onKeyDown={(event) => { if (event.key === "Escape") setIsOpen(false); }}>
  {languages.map((lang) => (
    <li key={lang.code}>
    <button type="button"
      aria-pressed={lang.code === selected}
      className={`lang-option ${lang.code === selected ? "selected" : ""}`}
      onClick={() => handleSelect(lang.code)}
    >
      <img src={lang.flag} alt={lang.label} className="flag-img" />
      <span className="label">{lang.label}</span>
      {lang.code === selected && <span className="check">✔️</span>}
    </button>
    </li>
  ))}
</ul>

      )}
    </div>
  );
};

export default LanguageDropdown;
